import {Component} from "@angular/core";

/**
 * Header bar (aka "Chrome") that runs along the top of the screen.
 * The chrome may optionally include some action controls by adding a <fui-chrome-controls> element
 *
 * See fui-chrome-control-link
 * See fui-chrome-control-dropdown
 *
 * <fui-chrome>
 *   <fui-chrome-controls>
 *      <wbo-localisation-chrome-control></wbo-localisation-chrome-control>
 *      <wbo-chrome-control-account></wbo-chrome-control-account>
 *    </fui-chrome-controls>
 * </fui-chrome>
 */
@Component({
    selector: "fui-chrome",
    templateUrl: "./chrome.component.html",
    styleUrls: ["./chrome.component.scss"]
})
export class FUIChromeComponent {
}
